export const  DB_CONFIG = {
    apiKey: "AIzaSyBGyrp7_WNO5lLRpjD_PRfqM0I8GICCK8E",
    authDomain: "neat-reddit-post-explorer.firebaseapp.com",
    databaseURL: "https://neat-reddit-post-explorer.firebaseio.com",
    projectId: "neat-reddit-post-explorer",
    storageBucket: "neat-reddit-post-explorer.appspot.com",
    messagingSenderId: "535144818742"
};


// WEBPACK FOOTER //
// ./src/Config/config.js